import { Box, Image, Text, Timer } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { PromoTimerProps } from './PromoTimer.types';

function PromoTimer({
  promotionEndDate,
  onCountDownComplete,
}: PromoTimerProps) {
  return (
    <Box
      testID="promo-timer"
      position="absolute"
      top="space-200"
      right="space-200"
      zIndex={10}
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      backgroundColor="secondaryBackground"
      paddingHorizontal="space-200"
      paddingVertical="space-100"
      borderRadius="radius-300"
    >
      <Image name="common.DarkClock" width="space-500" height="space-500" />
      <Box flexDirection="row" gap="space-050">
        <Text
          variant="caption"
          color="darkSurfacePrimary"
          locNS="promos"
          locKey="promoEndsIn"
        />
        <Timer
          variant="caption"
          color="darkSurfacePrimary"
          displayMode="precise"
          time={promotionEndDate}
          onCountDownComplete={onCountDownComplete}
        />
      </Box>
    </Box>
  );
}

export default memo(PromoTimer);
